export default "__VITE_ASSET__DddY$9_h__"